import { GuestDetails, RsvpDetails, StepsTranslationsStrings } from "../../models/api/rsvpApiTypes"
import { CORE_STEP_NAMES, TranslationsStringsType } from "../../models/enum/rsvpEnum"
import useStepNavigation from "../../hook/useStepNavigation"
import TextInput from "../Inputs/TextInput"

interface StepIntolerancesProps {
  buttonColor?: string
  backButtonColor?: string
  strings?: StepsTranslationsStrings[]
  rsvp: RsvpDetails
  setRsvp: (rsvp: RsvpDetails) => void
  setStep: (name: string) => void
  stepPipeline: string[]
}

export default function StepIntolerances({
  buttonColor,
  backButtonColor,
  strings,
  rsvp,
  setStep,
  setRsvp,
  stepPipeline,
}: StepIntolerancesProps) {
  const { goNext, goPrevious } = useStepNavigation(stepPipeline, CORE_STEP_NAMES.INTOLERANCES, setStep)

  const setIntolerances = (intolerances: string, guest: GuestDetails) => {
    const newGuests = rsvp.invitation.guests.map((g) => {
      if (g.id === guest.id) {
        g = {
          ...guest,
          rsvp: {
            accepted: g.rsvp.accepted,
            intolerances: intolerances.split(","),
            arrivalDate: g.rsvp.arrivalDate,
            email: g.rsvp.email,
            busTransferNeeded: g.rsvp.busTransferNeeded,
          },
        }
      }
      return g
    })
    setRsvp({ ...rsvp, invitation: { ...rsvp.invitation, guests: newGuests } })
  }

  return (
    <>
      {rsvp.invitation.guests.map((guest) => (
        <div key={guest.id} style={{ marginTop: "5px" }}>
          {guest.rsvp.accepted && guest.rsvpSettings.showIntolerances && (
            <>
              <label className="box-form-label">
                {guest.name} {guest.surname}
              </label>
              <TextInput
                className="box-form-input"
                placeholder={strings?.find((x) => x.type === TranslationsStringsType.PLACEHOLDER)?.value}
                value={guest.rsvp.intolerances.join(",")}
                onChange={(value) => setIntolerances(value ?? "", guest)}
              />
            </>
          )}
        </div>
      ))}

      <div style={{ display: "flex", flexDirection: "row" }}>
        <button
          style={{ backgroundColor: backButtonColor, borderColor: backButtonColor }}
          type="button"
          className="btn btn-primary box-button-left"
          onClick={goPrevious}
        >
          {strings?.find((x) => x.type === TranslationsStringsType.LEFTBUTTON)?.value}
        </button>
        <button
          type="button"
          className="btn btn-primary box-button-right"
          style={{ backgroundColor: buttonColor, borderColor: buttonColor }}
          onClick={goNext}
        >
          {strings?.find((x) => x.type === TranslationsStringsType.MAINBUTTON)?.value}
        </button>
      </div>
    </>
  )
}
